import { DatePipe } from '@angular/common';
import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject, input, InputSignal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PlannerDayStateService } from 'src/app/pages/custom-route/shared/planner/services/planner-day-state.service';
import { DurationPipe } from 'src/app/pipes/duration.pipe';

@Component({
  selector: 'app-card',
  standalone: true,
  imports: [
    TranslateModule, 
    DurationPipe, 
    DatePipe
  ],
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CardComponent {
  public img: InputSignal<string> = input.required<string>();
  public title: InputSignal<string> = input.required<string>();
  public startDate: InputSignal<Date> = input.required<Date>();
  public durationMinutes: InputSignal<number> = input.required<number>();
  public isPointToDelete: InputSignal<boolean> = input(false);
  public isPointToAddNew: InputSignal<boolean> = input(false);
  public isPointToReplace: InputSignal<boolean> = input(false);
  
  private _plannerDayStateService = inject(PlannerDayStateService);
  
  private readonly _dayToShowIndex = computed(() => this._plannerDayStateService.dayToShowIndex());
  get dayToShowIndex() {
    return this._dayToShowIndex();
  }
  
  public isImgError: boolean = false;
  
  handleImgError(): void {
    this.isImgError = true;
  }
}
